import React, {
  useEffect,
  useState,
} from "react";

import {
  useLocation,
} from "react-router-dom";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

import {
  FaImages,
  FaBookOpen,
  FaBirthdayCake,
  FaAward,
  FaUserGraduate,
} from "react-icons/fa";

const LifePage = () => {
  const [open, setOpen] =
    useState(false);

  const location =
    useLocation();

  const queryParams =
    new URLSearchParams(
      location.search
    );

  const typeFromURL =
    queryParams.get("type") ||
    "all";

  const [activeTab, setActiveTab] =
    useState(typeFromURL);

  const [academics, setAcademics] =
    useState([]);

  const [
    galleryAwards,
    setGalleryAwards,
  ] = useState([]);

  const [birthday, setBirthday] =
    useState([]);

  const [student, setStudent] =
    useState([]);

  useEffect(() => {
    setActiveTab(typeFromURL);
  }, [typeFromURL]);

  useEffect(() => {
    fetch(
      "https://stjosephweb.ilakshyaerp.in/api/academics"
    )
      .then((res) =>
        res.json()
      )
      .then((data) =>
        setAcademics(
          Array.isArray(data)
            ? data
            : []
        )
      );

    fetch(
      "https://stjosephweb.ilakshyaerp.in/api/galleryAwards"
    )
      .then((res) =>
        res.json()
      )
      .then((data) =>
        setGalleryAwards(
          Array.isArray(data)
            ? data
            : []
        )
      );

    fetch(
      "https://stjosephweb.ilakshyaerp.in/api/birthday"
    )
      .then((res) =>
        res.json()
      )
      .then((data) =>
        setBirthday(
          Array.isArray(data)
            ? data
            : []
        )
      );

    fetch(
      "https://stjosephweb.ilakshyaerp.in/api/student"
    )
      .then((res) =>
        res.json()
      )
      .then((data) =>
        setStudent(
          Array.isArray(data)
            ? data
            : []
        )
      );
  }, []);

  const allData = [
    ...academics.map((i) => ({
      ...i,
      type: "academics",
    })),

    ...galleryAwards.map(
      (i) => ({
        ...i,
        type: "galleryAwards",
      })
    ),

    ...birthday.map((i) => ({
      ...i,
      type: "birthday",
    })),

    ...student.map((i) => ({
      ...i,
      type: "student",
    })),
  ];

  const filteredData =
    activeTab === "all"
      ? allData
      : allData.filter(
          (item) =>
            item.type === activeTab
        );

  const getImage = (item) => {
    if (
      item.type === "academics"
    )
      return `https://stjosephweb.ilakshyaerp.in/uploads/academics/${item.image}`;

    if (
      item.type ===
      "galleryAwards"
    )
      return `https://stjosephweb.ilakshyaerp.in/uploads/galleryAwards/${item.image}`;

    if (
      item.type === "birthday"
    )
      return `https://stjosephweb.ilakshyaerp.in/uploads/birthday/${item.image}`;

    if (
      item.type === "student"
    )
      return `https://stjosephweb.ilakshyaerp.in/uploads/student/${item.image}`;
  };

  const getTagStyle = (type) => {
    switch (type) {
      case "academics":
        return "bg-blue-100 text-blue-700";

      case "galleryAwards":
        return "bg-yellow-100 text-yellow-700";

      case "birthday":
        return "bg-pink-100 text-pink-700";

      case "student":
        return "bg-green-100 text-green-700";

      default:
        return "bg-gray-100 text-gray-700";
    }
  };

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      {/* HERO */}
      <section className="relative overflow-hidden bg-gradient-to-r from-[#072F5F] via-[#0B4F9C] to-[#072F5F] py-20 md:py-28">

        {/* DESIGN */}
        <div className="absolute inset-0 opacity-10">

          <div className="absolute top-0 left-0 w-72 h-72 bg-white rounded-full blur-3xl"></div>

          <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#D4A017] rounded-full blur-3xl"></div>

        </div>

        <div className="relative max-w-7xl mx-auto px-5 md:px-10 text-center">

          <div className="w-20 h-20 rounded-3xl bg-white/10 backdrop-blur-md flex items-center justify-center text-white text-3xl mx-auto shadow-2xl">

            <FaImages />

          </div>

          <span className="inline-block mt-6 text-[#D4A017] uppercase tracking-[5px] text-sm font-bold">

            School Gallery

          </span>

          <h1 className="text-4xl md:text-6xl font-extrabold text-white mt-5">

            LIFE AT SCHOOL

          </h1>

          <p className="text-gray-200 text-lg mt-6 max-w-3xl mx-auto leading-8">

            Explore academics,
            achievements, birthdays,
            student creativity and
            memorable moments of
            school life.

          </p>

        </div>

      </section>

      {/* CONTENT */}
      <section className="w-full bg-[#f7f9fc] py-16 md:py-24 overflow-x-hidden">

        <div className="max-w-7xl mx-auto px-5 md:px-10">

          {/* TABS */}
          <div className="flex flex-wrap justify-center gap-4 mb-16">

            <button
              onClick={() =>
                setActiveTab("all")
              }
              className={`px-6 py-3 rounded-2xl font-semibold transition-all duration-300 shadow-md ${
                activeTab === "all"
                  ? "bg-[#072F5F] text-white"
                  : "bg-white text-[#072F5F] hover:bg-[#072F5F] hover:text-white"
              }`}
            >
              All
            </button>

            <button
              onClick={() =>
                setActiveTab(
                  "academics"
                )
              }
              className={`px-6 py-3 rounded-2xl font-semibold transition-all duration-300 shadow-md flex items-center gap-2 ${
                activeTab ===
                "academics"
                  ? "bg-[#072F5F] text-white"
                  : "bg-white text-[#072F5F] hover:bg-[#072F5F] hover:text-white"
              }`}
            >

              <FaBookOpen />

              Academics

            </button>

            <button
              onClick={() =>
                setActiveTab(
                  "galleryAwards"
                )
              }
              className={`px-6 py-3 rounded-2xl font-semibold transition-all duration-300 shadow-md flex items-center gap-2 ${
                activeTab ===
                "galleryAwards"
                  ? "bg-[#D4A017] text-white"
                  : "bg-white text-[#072F5F] hover:bg-[#D4A017] hover:text-white"
              }`}
            >

              <FaAward />

              Gallery & Awards

            </button>

            <button
              onClick={() =>
                setActiveTab(
                  "birthday"
                )
              }
              className={`px-6 py-3 rounded-2xl font-semibold transition-all duration-300 shadow-md flex items-center gap-2 ${
                activeTab ===
                "birthday"
                  ? "bg-pink-500 text-white"
                  : "bg-white text-[#072F5F] hover:bg-pink-500 hover:text-white"
              }`}
            >

              <FaBirthdayCake />

              Birthday

            </button>

            <button
              onClick={() =>
                setActiveTab(
                  "student"
                )
              }
              className={`px-6 py-3 rounded-2xl font-semibold transition-all duration-300 shadow-md flex items-center gap-2 ${
                activeTab ===
                "student"
                  ? "bg-green-600 text-white"
                  : "bg-white text-[#072F5F] hover:bg-green-600 hover:text-white"
              }`}
            >

              <FaUserGraduate />

              Student Work

            </button>

          </div>

          {/* GRID */}
          {filteredData.length >
          0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">

              {filteredData.map(
                (item, i) => (
                  <div
                    key={i}
                    className="group bg-white rounded-[30px] overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
                  >

                    {/* IMAGE */}
                    <div className="relative overflow-hidden">

                      <img
                        src={getImage(
                          item
                        )}
                        alt="life"
                        className="w-full h-[260px] object-cover group-hover:scale-110 transition-all duration-700"
                      />

                      {/* OVERLAY */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>

                      {/* TAG */}
                      <div
                        className={`absolute top-4 left-4 px-4 py-2 rounded-full text-xs font-bold uppercase tracking-wide shadow-md ${getTagStyle(
                          item.type
                        )}`}
                      >
                        {item.type ===
                        "galleryAwards"
                          ? "Gallery"
                          : item.type}
                      </div>

                    </div>

                    {/* CONTENT */}
                    <div className="p-6">

                      <h3 className="text-2xl font-bold text-[#072F5F] leading-snug">

                        {item.title ||
                          item.name ||
                          "School Activity"}

                      </h3>

                      

                    </div>

                  </div>
                )
              )}

            </div>
          ) : (
            <div className="bg-white rounded-[35px] shadow-xl border border-gray-100 p-16 text-center">

              <div className="w-20 h-20 rounded-full bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-3xl mx-auto mb-6">

                <FaImages />

              </div>

              <h3 className="text-3xl font-bold text-[#072F5F]">

                No Data Available

              </h3>

              <p className="text-gray-500 mt-4 text-lg">

                Content will appear here soon.

              </p>

            </div>
          )}

        </div>

      </section>

      <Footer />
    </>
  );
};

export default LifePage;